export const ESTIMATED_HOURS_VARIATION_STATUS = {
  MATCHING: 'MATCHING',
  MISSING_ESTIMATE: 'MISSING_ESTIMATE',
  OVER: 'OVER',
  UNDER: 'UNDER'
};
